module.exports = __webpack_public_path__ + "img/codrops.36cf6b46.svg";